export const EurikaaMark = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 30"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 1.5C6.477 1.5 2 5.977 2 11.5c0 6.75 8.15 15.05 9.34 16.22a.94.94 0 0 0 1.32 0C13.85 26.55 22 18.25 22 11.5 22 5.977 17.523 1.5 12 1.5Z"
      fill="url(#eur-grad)"
    />
    <circle cx="12" cy="11.3" r="3.6" fill="#ffffff" />
    <defs>
      <linearGradient id="eur-grad" x1="4" y1="2" x2="20" y2="28" gradientUnits="userSpaceOnUse">
        <stop stopColor="#818CF8" />
        <stop offset="1" stopColor="#6366F1" />
      </linearGradient>
    </defs>
  </svg>
);

const Logo = ({ className = "", markClass = "h-7 w-auto" }) => (
  <img
    src="/assets/eurikaa-logo.png"
    alt="eurikaa"
    className={`${markClass} ${className}`}
  />
);

export default Logo;
